import { createSlice } from "@reduxjs/toolkit"
import { getDropdownData, getJobTitlesList } from "store/actions/commonAction"

const initialState = {
  dropdownData: {},
  jobTitlesList: [],
}

const usersSlice = createSlice({
  name: "dropdown",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getDropdownData.pending, state => {})
      .addCase(getDropdownData.fulfilled, (state, action) => {
        const { success, data } = action.payload
        if (success) {
          state.dropdownData = data
        }
      })
      .addCase(getDropdownData.rejected, (state, action) => {})

    builder
      .addCase(getJobTitlesList.pending, state => {})
      .addCase(getJobTitlesList.fulfilled, (state, action) => {
        const { success, data } = action.payload
        if (success) {
          state.jobTitlesList = data
        }
      })
      .addCase(getJobTitlesList.rejected, (state, action) => {})
  },
})

export default usersSlice.reducer
